import { ASSETS } from "@/lib/assets";
import { useI18n } from "@/lib/i18n";
import { SECTIONS } from "@/constants/testIds";

export default function Identity() {
  const { t } = useI18n();
  return (
    <section
      id="about"
      data-testid={SECTIONS.identity}
      className="relative bg-[#070707] text-white py-28 lg:py-40 overflow-hidden border-t border-white/5"
    >
      <div className="mx-auto max-w-6xl px-6 lg:px-10 grid lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-5 flex justify-center">
          <div className="relative w-full max-w-[360px] aspect-square bg-[#0d0d0d] border border-white/10 flex items-center justify-center group">
            <img
              src={ASSETS.logo}
              alt="Stanimirović monogram"
              className="w-1/2 h-1/2 object-contain transition-transform duration-700 group-hover:scale-105"
            />
            <span className="absolute top-4 left-4 text-[10px] tracking-[0.32em] text-white/35 uppercase">
              Monogram
            </span>
            <span className="absolute bottom-4 right-4 text-[10px] tracking-[0.32em] text-[#c5a572] uppercase">
              Est. 2015
            </span>
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#c5a572]" />
            <span className="text-[11px] tracking-[0.42em] text-[#c5a572] uppercase">
              {t.identity.eyebrow}
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            {t.identity.title}
          </h2>
          <p className="mt-8 text-white/65 leading-relaxed max-w-xl font-light">
            {t.identity.body}
          </p>
        </div>
      </div>
    </section>
  );
}
